function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import classnames from 'classnames';
import classes from './underlined-input.scss';
// New underlined input using material ui v4
const UnderlinedInput = ({
  input,
  label,
  type,
  className,
  containerClassName,
  errorClassName,
  isLimitedEdition,
  dataInput = '',
  autoComplete,
  meta: {
    touched,
    active,
    error,
    warning
  },
  children
}) => {
  const [isPasswordShown, setIsPasswordShown] = useState(false);
  const showNotification = touched && !active;
  const errorMessage = showNotification ? error : '';
  const warningMessage = showNotification ? warning : '';
  const errorUnderlineClass = errorMessage ? classes.error : '';
  const warningUnderlineClass = warningMessage ? classes.warning : '';
  const isPasswordType = type === 'password';
  const onClickShowPassword = () => {
    setIsPasswordShown(!isPasswordShown);
  };
  const onMouseUpDownPassword = e => {
    e.preventDefault();
  };
  return /*#__PURE__*/React.createElement("div", {
    "data-input-block": dataInput,
    className: classnames(classes.container, containerClassName)
  }, /*#__PURE__*/React.createElement(TextField, {
    type: isPasswordType ? isPasswordShown ? 'text' : 'password' : type,
    label: label,
    error: showNotification,
    variant: "standard",
    inputProps: input,
    "data-input": dataInput,
    helperText: errorMessage || warningMessage,
    autoComplete: autoComplete,
    classes: {
      root: classnames(classes.textField, className)
    },
    InputProps: _objectSpread({
      classes: {
        root: classes.input,
        underline: classnames(classes.underline, warningUnderlineClass, errorUnderlineClass)
      }
    }, isPasswordType && {
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React.createElement("div", {
        onClick: onClickShowPassword,
        onMouseDown: onMouseUpDownPassword,
        onMouseUp: onMouseUpDownPassword
      }, isPasswordShown ? /*#__PURE__*/React.createElement("div", {
        className: classnames(classes.passwordVisibilityBlock, {
          [classes.orangeBlock]: isLimitedEdition
        })
      }, /*#__PURE__*/React.createElement(VisibilityOff, null), /*#__PURE__*/React.createElement("span", null, "Hide")) : /*#__PURE__*/React.createElement("div", {
        className: classnames(classes.passwordVisibilityBlock, {
          [classes.orangeBlock]: isLimitedEdition
        })
      }, /*#__PURE__*/React.createElement(Visibility, null), /*#__PURE__*/React.createElement("span", null, "Show"))))
    }),
    InputLabelProps: {
      classes: {
        root: classes.floatingLabel
      }
    },
    FormHelperTextProps: {
      classes: {
        root: classnames(classes.helperText, errorClassName)
      }
    }
  }), children);
};
export default UnderlinedInput;